import { Fragment } from 'react';
import { linkify } from '../utils/emailText';

// Renders email text with its links shortened and clickable. Text only - no
// HTML from the email is ever injected into the page.
export default function EmailText({ text }) {
  return (
    <>
      {linkify(text).map((seg, i) => (seg.url
        ? <a key={i} href={seg.url} target="_blank" rel="noopener noreferrer">{seg.label}</a>
        : <Fragment key={i}>{seg.text}</Fragment>))}
    </>
  );
}
